import { useTranslation } from 'react-i18next';
import { travelCostSettingsSchema } from './schema';
import { ADMIN_SETTINGS_GROUP } from 'RestAPIs/endpoints';
import { useSaveResource } from 'RestAPIs/useSaveResource';
import { AdminSettingsFormWrapper } from 'components/shared/AdminSettings/AdminSettingsFormWrapper';
import FormContent from './FormContent';
import Box from '@mui/material/Box';
import FormSkeleton from '../../../Tables/CLA/PremiumPay/components/Form/components/FormSkeleton';
import { createTimeString, groupName } from './hooks/useConvertedAdminSettings';
import { settingsAtPayloadTravelCost } from '../../utils';
import { useGetAdminSettings } from '../../../../../queries';
import { AdminSettingsResponse } from '../../../../types';
import { transformAdminSettingsToFormValues } from '../../../../utils';

const TravelCostSettings = () => {
  const { t } = useTranslation('common');
  const { data: settingsArray = [], isFetching: isSettingsFetching } =
    useGetAdminSettings<AdminSettingsResponse>(groupName);

  const { mutate, isLoading } = useSaveResource({
    url: ADMIN_SETTINGS_GROUP,
    id: settingsArray[0]?.groupId,
    invalidateQueryKey: [groupName],
    message: { error: t('travelCost.saveErrorMessage') }
  });

  const settings = settingsArray[0] ?? undefined;

  const onSubmit = (formData) => {
    mutate(settingsAtPayloadTravelCost(formData, settings));
  };

  const convertedData = transformAdminSettingsToFormValues(settings);

  return (
    <div style={{ paddingTop: '25px' }}>
      {settings ? (
        <AdminSettingsFormWrapper
          submitForm={onSubmit}
          schema={travelCostSettingsSchema}
          isFetching={isSettingsFetching}
          isLoading={isLoading}
          data={{
            ...convertedData,
            active: settingsArray[0].active,
            travel_exp_max_interval: createTimeString(
              settingsArray,
              'travel.exp.max.interval'
            )
          }}
        >
          <FormContent />
        </AdminSettingsFormWrapper>
      ) : (
        <Box my={3}>
          <FormSkeleton />
        </Box>
      )}
    </div>
  );
};

export default TravelCostSettings;
